import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationTemplatesAccessService } from '../services';

/**
 * Guard delle pagine dei testi delle email personalizzati per azienda (#2103).
 *
 * Entra solo chi il Notifier riconosce come gestore dei testi dell'azienda corrente: aspetta la
 * capability (`NotificationTemplatesAccessService`, che la chiede una volta sola) e senza manda a
 * /dashboard. Un errore del Notifier vale «non gestisce».
 */
export const notificationTemplatesGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const access = inject(NotificationTemplatesAccessService);
  const router = inject(Router);

  return access.ensureLoaded().pipe(
    map(canManage => canManage || router.createUrlTree(['/dashboard'])),
  );
};
